import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_STIDestListReverseScan = _resolveComponent("STIDestListReverseScan")!
  const _component_STIDestOldList = _resolveComponent("STIDestOldList")!

  return (_ctx.isReverseScanSTIDest)
    ? (_openBlock(), _createBlock(_component_STIDestListReverseScan, { key: 0 }))
    : (_openBlock(), _createBlock(_component_STIDestOldList, { key: 1 }))
}